module.exports = __webpack_public_path__ + "img/registerRed.5f889f8c.jpg";